import { createAsyncThunk } from '@reduxjs/toolkit';
import usersService from '../../../services/users';
import { CreateUserPayload, UserArgs } from '../../../types/users';

export const getUsers = createAsyncThunk('users/getUsers', async (args: UserArgs, thunkAPI) => {
  const { signal } = thunkAPI;
  try {
    return await usersService.getUsers(args, signal);
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.message);
  }
});

export const createUser = createAsyncThunk('users/createUser', async (args: CreateUserPayload, thunkAPI) => {
  try {
    return await usersService.createUser(args);
  } catch (error: any) {
    console.log(error);
    const message = error?.response?.data?.message ?? 'Something went wrong';
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateUser = createAsyncThunk('users/updateUser', async (args: CreateUserPayload, thunkAPI) => {
  try {
    return await usersService.updateUser(args);
  } catch (error: any) {
    console.log(error);
    const message = error?.response?.data?.message ?? 'Something went wrong';
    return thunkAPI.rejectWithValue(message);
  }
});
